import push from '../utils/push';

/** @typedef {import('./product-datalayer').GAProduct} GAProduct */

/**
 * @param {string} currencyCode 
 * @param {GAProduct} product 
 */
function sendClick(currencyCode, product) {
    push({
        'event': 'product-click',
        'listProductFilters': 'undefined',
        'ecommerce': {
            'currencyCode': currencyCode,
            'click': {
                'actionField': {
                    'list': product.list
                },
                'products': [ product ]
            }
        }
    });
}

/**
 * @param {string} currencyCode 
 * @param {Array<GAProduct>} products 
 */
function sendImpression(currencyCode, products) {
    push({
        'event': 'product-impression',
        'ecommerce': {
            'currencyCode': currencyCode,
            'impressions': products
        }
    });
}

window.VCA = window.VCA || {};

window.VCA.productCardDatalayer = {
    sendClick,
    sendImpression
};

export {
    sendClick,
    sendImpression
};
